<script>
    import Layout from "../../layouts/main";
    import PageHeader from "../../components/page-header";
    import subProductList from "./sub-product-list";
    export default {
    components: { Layout, PageHeader, subProductList },
    data() {
        return {};
    }
    };

</script>

<template>
  <Layout>
    <sub-product-list/>
  </Layout>
</template>